import React, { useEffect, useState } from "react";
import { ResponsiveLine } from "@nivo/line";
import { Spin } from "antd";
import ApiService from "../../Components/apiService.js";
import { BASE_URL } from "../../Components/Constant";

const Line = ({ reportId }) => {
    const [lineData, setLineData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!reportId) return;

        const apiServiceForRecords = new ApiService(
            `${BASE_URL}/mt_reports/${reportId}`,
            { "Content-Type": "application/json" },
            "GET"
        );

        apiServiceForRecords
            .makeCall()
            .then((response) => {

                if (response.report && response.data.length > 0) {
                    const aggregationFields = response.report.aggregation_fields || ["AnnualRevenue"];
                    const groupField = response.report.group_fields?.[0] || "Name";

                    // Transform data into line chart format
                    const formattedData = aggregationFields.map((field) => ({
                        id: field,
                        color: `hsl(${Math.random() * 360}, 70%, 50%)`,
                        data: response.data.map((record) => ({
                            x: record[groupField] || "Unknown",
                            y: record[field] || 0
                        }))
                    }));

                    setLineData(formattedData);
                } else {
                    setLineData([]);
                }
                setLoading(false);
            })
            .catch((err) => {
                setError(err);
                setLoading(false);
            });
    }, [reportId]);

    if (!reportId) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'orange', fontStyle: 'bold' }}>
            Report not attached correctly.
        </div>
    );
    if (loading) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Spin size="large" />
        </div>
    );
    if (error) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'red', fontStyle: 'bold' }}>
            Error: {error.message || error.error}
        </div>
    );

    return (
        <ResponsiveLine
            data={lineData}
            margin={{ top: 50, right: 120, bottom: 65, left: 70 }}
            xScale={{ type: "point" }}
            yScale={{ type: "linear", stacked: false, min: "auto", max: "auto" }}
            axisBottom={{
                orient: "bottom",
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: "Group Field",
                legendOffset: 36,
                legendPosition: "middle"
            }}
            axisLeft={{
                orient: "left",
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: "Value",
                legendOffset: -65,
                legendPosition: "middle"
            }}
            dotSize={10}
            dotColor="inherit:darker(0.3)"
            dotBorderWidth={2}
            dotBorderColor="#ffffff"
            enableDotLabel={true}
            dotLabel="y"
            dotLabelYOffset={-12}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
            legends={[
                {
                    anchor: "bottom-right",
                    direction: "column",
                    translateX: 100,
                    itemWidth: 80,
                    itemHeight: 20,
                    symbolSize: 12,
                    symbolShape: "circle",
                    symbolBorderColor: "rgba(0, 0, 0, .5)"
                }
            ]}
        />
    );
};

export default Line;
